export function useDefaultValue<T>(value: T | null | undefined, defaultVal: T): T {
  if (value) return value;
  return defaultVal;
}
